const PURCHASE_KEY = "RESTROPROSAAS__PURCHASE__PRINT";

export function getDetailsForPurchasePrint() {
    return JSON.parse(localStorage.getItem(PURCHASE_KEY));
}

export function setDetailsForPurchasePrint(details) {
    localStorage.setItem(PURCHASE_KEY, JSON.stringify(details));
}
